<template>
  <div id="home">
    <h1 class="title">‎‏‏‎ ‎</h1>
    <div class="section-list">
      <div v-for="(item, index) in sections" class="section">
        <router-link :to="item.url" :event="item.disabled ? '' : 'click'">
          <div class="icon" :class="{ disabled: item.disabled }">
            <router-link :to="item.url + '/add'"
              ><div
                v-if="typeof item.new === 'undefined' || item.new"
                class="add"
              ></div
            ></router-link>
            <img class="img" :src="item.img" />
          </div>
          <div class="content">{{ item.name }}</div>
        </router-link>
      </div>
    </div>

    <div class="events">
      <div class="title">
        <h1>{{ $t("events.active") }}</h1>
      </div>
      <v-container grid-list-md text-xs-center>
        <v-layout row wrap>
          <v-flex
            xs6
            class="event"
            v-for="(event, key) in events_active"
            :key="key"
          >
            <router-link :to="event.url">
              <v-card>
                <div class="go"></div>
                <div :class="'logo e' + event.type">
                  <img :src="event.img" />
                </div>
                <v-card-title primary-title>
                  <div class="content">
                    <div class="title">
                      <h3 class="headline mb-0">{{ event.name }}</h3>
                    </div>
                    <!-- <div class="subtitle">Comença el <strong>{{event.start_date | formatDate}}</strong></div> -->
                    <!-- <v-container grid-list-md text-xs-center class="stats">
                      <v-layout row wrap>
                        <v-flex xs4 class="stat">
                          <div class="icon">
                            <img src="/img/team2_2.svg"/>
                          </div>
                          <div class="label">Equips</div>
                          <div class="value">
                            <span class="success">{{event.confirmed}}</span> / {{ event.goals }} / <span class="success">{{event.interested}}</span>
                          </div>
                        </v-flex>
                        <v-flex xs4 class="stat">
                          <div class="icon">
                            <img src="/img/person.svg"/>
                          </div>
                          <div class="label">Competició</div>
                          <div class="value">
                            {{ event.competition }}
                          </div>
                        </v-flex>
                        <v-flex xs4 class="stat">
                          <div class="icon">
                            <img src="/img/person.svg"/>
                          </div>
                          <div class="label">Leads</div>
                          <div class="value">
                            {{ event.leads }}
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-container> -->
                  </div>
                </v-card-title>
              </v-card>
            </router-link>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
import Slider from "@/components/domain/home/Slider";
import i18n from "@/i18n";
import { isRestrictedEventTypeUserType } from "@/constants/backofficeUserTypes.js";

export default {
  name: "Home",
  components: { Slider },
  data() {
    return {};
  },
  computed: {
    sections() {
      const u = this.$store.getters["user/getUser"];
      if (u && isRestrictedEventTypeUserType(u.type)) {
        return [];
      }
      const base = [
        { url: "/club", name: i18n.t("clubs.label"), img: "/img/club_2.svg" },
        {
          url: "/event",
          name: i18n.t("events.label"),
          img: "/img/event.svg",
          new: false,
        },
        {
          url: "/person",
          name: i18n.t("persons.label"),
          img: "/img/users.svg",
        },
        {
          url: "/volunteer",
          name: i18n.t("volunteers.label"),
          img: "/img/users.svg",
          new: false,
        },
        { url: "/hotel", name: i18n.t("hotels.label"), img: "/img/hotel.svg" },
        {
          url: "/facility",
          name: i18n.t("facilitys.label"),
          img: "/img/court.svg",
        },
      ];
      if (u && parseInt(u.type, 10) === 1) {
        base.push({
          url: "/user",
          name: i18n.t("user.label"),
          img: "/img/users.svg",
        });
      }
      return base;
    },
    events_active() {
      var aEvents = this.$store.getters["events/getActives"]();
      var aResult = [];
      var self = this;
      aEvents.forEach((event) => {
        var interested = 0;
        var goals = 0;
        var confirmed = 0;
        if (event.is_campus == 0) {
          event.categories.forEach((cat) => {
            cat.teams.forEach((team) => {
              switch (parseInt(team.status)) {
                case 3:
                  interested++;
                  break;
                case 6:
                  confirmed++;
                  break;
              }
            });
            goals += parseInt(cat.goal);
          });
        }

        aResult.push({
          url: self.$root.formatEventUrl(event.name, event.edition),
          name: self.$root.formatEventName(event.name, event.edition),
          img: event.logo,
          type: event.type_id,
          goals: goals,
          interested: interested,
          confirmed: confirmed,
          competition: event.competition,
          leads: event.leads,
        });
      });
      return aResult;
    },
  },
  created() {
    this.$store.commit("setTitle", "MIC");
    // this.$store.dispatch('setPage', 'home' );

    var self = this;
    this.$overlay.loading();
    // this.$store.dispatch( 'events/loadActives' ).then( () => {
    self.$overlay.hide();
    // })
  },
  methods: {},
  filters: {
    formatDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

#container {
}

#home {
  padding: 20px 30px;
  overflow-y: auto !important;

  .section-list {
    width: 100%;
    position: relative;
    overflow: hidden;
    text-align: center;

    a {
      text-decoration: none;
    }

    .section {
      width: 125px;
      height: 125px;
      display: inline-block;
      margin: 0px 10px;
      margin-bottom: 35px;
      position: relative;
      text-align: center;

      .icon {
        width: 80%;
        height: 80%;
        border-radius: 50%;
        padding: 20px;
        position: relative;
        display: inline-block;
        background-color: #222;
        border: 5px solid tint(#222, 70%);
        -webkit-transition: border 200ms ease-out;
        -moz-transition: border 200ms ease-out;
        -o-transition: border 200ms ease-out;
        transition: border 200ms ease-out;

        &.disabled {
          opacity: 0.5;
        }

        .add {
          width: 30px;
          height: 30px;
          background: url("/img/add_2.svg");
          background-color: $complem-color;
          border-radius: 50%;
          border: 1px solid var(--main-color);
          position: absolute;
          top: -5px;
          right: -5px;
          content: " ";
          background-size: 20px;
          background-position: center;
          background-repeat: no-repeat;
          -webkit-transition: all 200ms ease-out;
          -moz-transition: all 200ms ease-out;
          -o-transition: all 200ms ease-out;
          transition: all 200ms ease-out;

          &:hover {
            width: 35px;
            height: 35px;
          }
        }

        &:hover {
          border: 8px solid tint(#222, 70%);
        }

        img {
          position: absolute;
          height: 50%;
          width: auto;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }

      .content {
        width: 100%;
        color: #192461;
        height: 30px;
        line-height: 30px;
        font-size: 18px;
        text-align: center;
        font-family: $text-light;
      }
    }
  }

  .events {
    margin-top: 50px;

    .title {
      h1 {
        font-size: 32px !important;
        text-align: center;
      }
    }

    .event {
      padding: 12px;

      .go {
        content: " ";
        width: 30px;
        height: 30px;
        background-image: url("/img/right-arrow.svg");
        background-size: 30px;
        background-position: center;
        position: absolute;
        top: 10px;
        right: 10px;
        display: none;
      }

      .logo {
        width: 100%;
        height: 85px;
        text-align: center;

        &.e1 {
          background-color: $main-color-e1;
        }
        &.e2 {
          background-color: $main-color-e2;
        }
        &.e3 {
          background-color: $main-color-e3;
        }
        &.e4,
        &.e12 {
          background-color: $main-color-e4;
        }
        &.e5 {
          background-color: $main-color-e5;
        }
        &.e13 {
          background-color: $main-color-e13;
        }
        &.e14 {
          background-color: $main-color-e14;
        }
        &.e15 {
          background-color: $main-color-e15;
        }
        &.e16 {
          background-color: $main-color-e16;
        }
        &.e17 {
          background-color: $main-color-e17;
        }

        img {
          height: 75px;
          width: auto;
          margin: 5px 0;
        }
      }

      .content {
        width: 100%;
        padding: 20px;

        .title {
          text-align: center;

          .headline {
            padding-left: 0;
            font-family: $title-bold !important;
            text-align: center;
          }
        }

        .subtitle {
          font-weight: lighter;
          margin-bottom: 20px;
          text-align: center;
          font-size: 14px;

          strong {
            font-size: 14px;
            font-weight: bold;
          }
        }

        .stats {
          .stat {
            display: inline-block;
            text-align: center;

            .icon {
              height: 35px;
              text-align: center;
              background-color: #eee;
              padding: 10px;
              border-radius: 100%;
              width: 35px;
              margin: 0 auto;

              img {
                height: 15px;
                opacity: 0.2;
              }
            }
            .label {
              font-size: 12px;
              font-weight: lighter;
              text-align: center;
            }

            .value {
              margin-top: 5px;
              font-size: 25px;
              color: #acacac;
              line-height: 24px;
              text-align: center;

              .success {
                color: #000;
                font-weight: bold;
                font-size: 22px;
              }
            }

            &:not(:first-child) {
              border-left: 1px solid #ddd;
            }
          }
        }
      }
    }
  }
}
</style>
